import { useState, useEffect } from "react";
import { getAddonsAccessStat, getAddonsList, getAddonsLogByDate } from "../../api/addon";

export function useAddonList({ filter }) {
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getAddons = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAddonsList(filter);
      setCustomers(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getAddons(filter);
  }, [filter]);

  return {
    customers,
    meta,
    loading,
    errorMsg,
    getAddons,
  };
}

export function useAddonStats({ filter }) {
  const [statistics, setStatistics] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getAddonsStat = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAddonsAccessStat(filter);
      setStatistics(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getAddonsStat(filter);
  }, [filter]);

  return {
    statistics,
    meta,
    loading,
    errorMsg,
    getAddonsStat,
  };
}

export function useAddonLogByDate({ date }) {
  const [logsByDate, setLogsByDate] = useState([]);
  // const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getLogs = async (date) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAddonsLogByDate(date);
      setLogsByDate(data.data);
    } catch (error) {
      console.log(error);
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getLogs(date);
  }, [date]);

  return {
    logsByDate,
    // meta,
    loading,
    errorMsg,
    getLogs,
  };
}
